<template>
  <section class="main">
    <div class="title">Use of Personal Data in Direct Marketing (Customer’s Consent)</div>
    
    <div class="question">
      <div class="en">Does the customer consent {{defaultCompany('en')}} use their personal data in direct marketing of {{company_name}} Insurance Company's products and services in respect of insurance services?</div>
      <div class="zh">客人是否同意 {{defaultCompany('zh')}} 使用他/她的個人資料，以供作直接促銷與 {{company_name}} 保險公司及保險業有關的產品和服務之用？</div>
    </div>

    <div class="radio">
      <el-radio-group
        v-model="formData.is_use">
        <el-radio
          v-for="(item, i) in consentsList"
          :key="i"
          :label="item.value">
          <span>{{item.en}}</span>
          <span>{{item.zh}}</span>
        </el-radio>
      </el-radio-group>
    </div>

    <div
      v-show="formData.is_use == 0"
      class="content">
      <!-- question 1 -->
      <div class="question">
        <div class="en">
          Do the customer consent to {{defaultCompany('en')}} to use their personal data in direct marketing in which channel(s)?
        </div>
        <div class="zh">
          客人是否同意 {{defaultCompany('zh')}}在以下途徑使用他/她的個人資料作直接促銷？
        </div>
      </div>

      <div
        class="btn pointer"
        @click="handleNotConsent">Customer does not consent to all 客人不同意所有</div>

      <div class="selections flex">
        <div
          v-for="(item, i) in marketingList"
          :key="i"
          class="item">
          <div class="option_title">{{item.name}}</div>
          <el-radio-group
            v-model="item.select">
            <el-radio :label="1">
              <span>Consent</span>
            </el-radio>
            <el-radio :label="0">
              <span>Not Consent</span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>

      <p class="tips">
        This will replace all previous choices the customer had sent to the insurer.
        <span
          class="icon pointer" 
          @click="handleDialog(1)">
          <font-awesome-icon icon="info-circle"></font-awesome-icon>
          <span class="text">Full text</span>
        </span>
      </p>

      <div class="line"></div>

      <!-- question 2 -->
      <div class="question">
        <div class="en">Does the customer consent {{defaultCompany('en')}} to <b> share their personal data with its group member companies and others </b> for direct marketing?</div>
        <div class="zh">客人是否同意 {{defaultCompany('zh')}} <b> 分享他/她的個人資料給及其公司集團成員及其他人,</b>使用作直接促銷？</div>
      </div>
      <div class="tips2">
        <span
          class="icon pointer"
          @click="handleDialog(2)">
          <font-awesome-icon icon="info-circle"></font-awesome-icon>
          <span class="text">Full text</span>
        </span>
      </div>
      <div class="radio">
        <el-radio-group
          v-model="formData.other_use">
          <el-radio
            v-for="(item, i) in consentsList"
            :key="i"
            :label="item.value">
            <span>{{item.en}}</span>
            <span>{{item.zh}}</span>
          </el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="dialog">
      <v-dialog
        v-model="dialog">
        <div class="header flex-sb">
          <span>{{dialogData.title}}</span>
          <font-awesome-icon
            icon="times"
            class="pointer"
            @click="dialog = false"></font-awesome-icon>
        </div>
        <div class="body">
          <p class="en">{{dialogData.en}}</p>
          <p class="zh">{{dialogData.zh}}</p>
        </div>
      </v-dialog>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'UsePersonalData',
  mixins: [MixinOptions],
  props:{
    company_name:{
      type: String,
      default: ''
    },
    marketing_data:{
      default: null
    }
  },
  data () {
    return {
      formData:{
        is_use: 0,
        use_data: [],
        other_use: 0
      },
      consentsList:[
        {
          en: 'The customer consents',
          zh: '客人同意',
          value: 1
        },
        {
          en: 'The customer does not consent',
          zh: '客人不同意',
          value: 0
        }
      ],
      dialog: false,
      dialogData:{
        title: '',
        en: '',
        zh: ''
      },
      marketingList: []
    }
  },
  computed:{
    defaultCompany(){
      return function(lang){
        if(this.company_name == ''){
          switch(lang){
            case 'en':
              return 'Insurer'
            case 'zh':
              return '保險公司'
          }
        }
        return this.company_name
      }
    }
  },
  watch:{
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          arr.forEach(item => {
            item.select = this.formData.use_data.includes(item.id)? 1 : 0
          })
          this.marketingList = arr
        }
      }
    },
    marketing_data:{
      immediate: true,
      deep: true,
      handler(val){
        if(val && Object.keys(val).length > 0){
          this.formData = JSON.parse(JSON.stringify(val))
        }
      }
    }
  },
  methods: {
    handleNotConsent(){
      this.marketingList.forEach(item => {
        item.select = 0
      })
    },
    
    handleDialog(type){
      if(type == 1){
        this.dialogData.title = 'Direct Marketing Materials Receiving Instruction'
        this.dialogData.en = `The above represents your present choice regarding whether or not to receive direct marketing materials from ${this.company_name} Insurance Company. This replaces any choice communicated by you to the company prior to this application. Please note that your above choice applies to the direct marketing of the classes of products, services and/or subjects as set out in the relevant Data Policy Notice of ${this.company_name} Insurance Company. Please also refer to the said Notice on the kinds of personal data which may be used in direct marketing.`
        this.dialogData.zh = `以上代表閣下現在對是否接收 ${this.company_name}保險公司 直銷推廣訊息的選擇 , 亦取代任何閣下之前已告知該公司的選擇。請注意，閣下以上的選擇適用於根據 ${this.company_name}保險公司 有關資料政策上所載的產品，服務及／或標的類別的直銷推廣。請閣下參考 ${this.company_name}保險公司 有關資料政策通告以得知在直銷推廣上可使用的個人資料的種類。`
      }
      if(type == 2){
        this.dialogData.title = 'Use of Personal Data in Direct Marketing Instruction'
        this.dialogData.en = `To improve and provide more comprehensive services, ${this.company_name} Insurance Company may provide your personal data to other members of the Group* and other persons for their use in direct marketing. (Please refer to the relevant Data Policy Notice of ${this.company_name} Insurance Company on the kinds of personal data and the classes of products, services and/or subjects which may be used in direct marketing, and the classes of persons to which your personal data may be provided for them to use in direct marketing.)
        
*The Group means the Company and its holding companies, branches, subsidiaries, representative offices and affiliates, wherever situated. Affiliates include the Company’s holding companies and and their respective branches, subsidiaries, representative offices and affiliates, wherever situated.`
        this.dialogData.zh = `為改善及提供更全面服務，${this.company_name}保險公司 可能會將閣下的個人資料提供予 ${this.company_name}保險公司集團* 其他成員及其他人作直銷推廣。（請閣下參考 ${this.company_name}保險公司 有關資料政策通告以得知 ${this.company_name}保險公司 在直銷推廣上可使用的個人資料的種類，閣下的個人資料可提供予甚麽類別的人士，以及該資料就甚麼類別的產品，服務及／或標的而使用。 ）

*${this.company_name}保險公司集團 包括但不限 ${this.company_name}保險公司 及其控股公司、分行、附屬公司、代表辦事處及附屬成員等，不論其所在地。附屬成員包括 ${this.company_name}保險公司 的控股公司之分行、附屬公司、代表辦事處及附屬成員，不論其所在地。`
      }
      this.dialog = true
    },

    handleSendData(){
      this.formData.use_data = []
      if(this.formData.is_use){
        this.formData.other_use = 0
      }else{
        this.marketingList.forEach(item => {
          if(item.select){
            this.formData.use_data.push(item.id)
          }
        })
      }
      console.log(this.formData)
      this.$emit('sendData', this.formData)
    }
  },
}
</script>
<style lang='scss' scoped>
.main{
  margin-top: 20px;
  .title{
    height: 24px;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
  }
  .question{
    margin: 20px 0;
    .en, .zh{
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: #24292E;
    }
    .zh{
      margin-top: 10px;
    }
  }
  .content{
    padding: 15px;
    background: #F6F8FA;
    border-radius: 6px;
    font-weight: 400;
    font-size: 14px;
    .btn{
      font-weight: 400;
      font-size: 14px;
      color: #0366D6;
    }
    .selections{
      margin: 20px 0;
      .item{
        width: 106px;
        .el-radio{
          padding-bottom: 4px;
          span{
            letter-spacing: -0.15px;
          }
        }
        .option_title{
          font-weight: 600;
          color: #24292E;
          margin-bottom: 8px;
        }
        &+.item{
          margin-left: 35px;
        }
      }
    }
    .tips{
      .icon{
        margin-left: 11px;
        color: #0366D6;
        .text{
          margin-left: 9px;
        }
      }
    }
    .tips2{
      margin: 10px 0 20px 0;
      .icon{
        color: #0366D6;
        .text{
          margin-left: 9px;
        }
      }
    }
  }
  .line{
    border: 1px solid #D1D5DA;
    margin: 20px 0;
  }

  .dialog{
    .header{
      background: #F6F8FA;
      border: 1px solid #E1E4E8;
      border-radius: 6px 6px 0px 0px;
      padding: 16px;
      height: 52px;
      font-weight: 600;
      color: #1B1F23;
    }
    .body{
      padding: 20px 15px 15px;
      p{
        white-space:pre-line
      }
      p+p{
        margin-top: 20px;
      }
    }
  }
}
.el-radio{
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  /deep/.el-radio__label{
    display: flex;
    flex-direction: column;
    padding-left: 8px;
    span{
      font-weight: 600;
      font-size: 14px;
      height: 20px;
      letter-spacing: -0.15px;
      color: #24292E;
    }
    span+span{
      margin-top: 4px;
    }
  }
}
/deep/.el-dialog{
  border-radius: 6px;
}
</style>